/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-private-classes */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Tab from 'DesignManagerIde/components/tabs/Tab';
import { findDOMNode } from 'react-dom';
import UITabs from 'UIComponents/nav/UITabs';
import HorizontalScrollContainer from 'DesignComponents/scroll/HorizontalScrollContainer';

class Tabs extends PureComponent {
  constructor(...args) {
    super(...args);

    this.setActiveTabRef = ref => {
      this.__activeTabRef = ref;
    };
  }

  componentDidMount() {
    if (this.props.activeId) {
      this.setActiveTabVisible();
    }

    this.__domNode = findDOMNode(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.tabsOrder.length > prevProps.tabsOrder.length || this.props.activeId !== prevProps.activeId || this.props.isScrollActiveTabIntoViewRequested) {
      this.setActiveTabVisible();
    }
  }

  setActiveTabVisible() {
    const activeTab = findDOMNode(this.__activeTabRef);

    if (activeTab) {
      window.requestAnimationFrame(() => {
        activeTab.scrollIntoView({
          block: 'end',
          behavior: 'smooth'
        });
      });
    }
  }

  renderTabs() {
    const {
      tabsOrder,
      openContextMenu,
      activeId
    } = this.props;
    return tabsOrder.map(tabId => {
      const tabProps = {
        openContextMenu,
        tabsOrder,
        activeId
      };

      if (activeId === tabId) {
        tabProps.ref = this.setActiveTabRef;
      }

      return /*#__PURE__*/_jsx(Tab, Object.assign({
        tabId: tabId
      }, tabProps), tabId);
    });
  }

  render() {
    const tabs = this.renderTabs();
    return /*#__PURE__*/_jsx(HorizontalScrollContainer, {
      children: /*#__PURE__*/_jsx(UITabs, {
        use: "enclosed",
        moreTabsRenderer: null,
        className: "file-tabs private-tabs",
        children: tabs
      })
    });
  }

}

Tabs.propTypes = {
  tabsOrder: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])).isRequired,
  openContextMenu: PropTypes.func.isRequired,
  activeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  shouldScrollActiveTabIntoView: PropTypes.bool.isRequired,
  toggleShouldScrollActiveTabIntoView: PropTypes.func.isRequired,
  isScrollActiveTabIntoViewRequested: PropTypes.bool
};
Tabs.defaultProps = {
  tabsOrder: [],
  activeId: null
};
export default Tabs;